/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

/**
 * @brief Basic APIs
 */
export const BasicAPIs = [
  {
    action: 'getScenes',
    apiPath: '/getScenes',
    method: 'post',
  },
  {
    action: 'saveSceneProfile',
    apiPath: '/saveSceneProfile',
    method: 'post',
  },
  {
    action: 'removeAvatarBg',
    apiPath: '/removeAvatarBg',
    method: 'post',
  },
  {
    action: 'generateCompanionFrames',
    apiPath: '/generateCompanionFrames',
    method: 'post',
  },
  {
    action: 'analyzeAvatarOcclusion',
    apiPath: '/analyzeAvatarOcclusion',
    method: 'post',
  },
  {
    action: 'uploadAsset',
    apiPath: '/uploadAsset',
    method: 'post',
  },
  {
    action: 'getCompanionProfiles',
    apiPath: '/getCompanionProfiles',
    method: 'post',
  },
  {
    action: 'saveCompanionProfiles',
    apiPath: '/saveCompanionProfiles',
    method: 'post',
  },
] as const;

/**
 * @brief Basic APIs
 */
export const AigcAPIs = [
  {
    action: 'StartVoiceChat',
    apiPath: '/proxy',
    method: 'post',
  },
  {
    action: 'UpdateVoiceChat',
    apiPath: '/proxy',
    method: 'post',
  },
  {
    action: 'StopVoiceChat',
    apiPath: '/proxy',
    method: 'post',
  },
] as const;
